import { Avatar } from '@eventbrite/eds-avatar';
import { Button } from '@eventbrite/eds-button';
import { CalendarChunky as CalendarChunkySVG } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { ConfirmationModalBody } from '../../../../components/ConfirmationOverlay';

const SIGNIN_CONFIRMATION_TEXT = gettext(
    'Sign in to see events </br>from organizers you follow',
);

const SigninConfirmationModalContent = () => {
    // Don't try to render the URL during SSR, but instead render no referrer
    // first for hydration:
    const [referrerPath, setReferrerPath] = React.useState('');
    React.useEffect(() => {
        const referrer = `${window.location.pathname}${
            window.location.search ? window.location.search + '&' : '?'
        }followed_orgs=1`;
        setReferrerPath(`?referrer=${referrer}`);
    }, []);

    return (
        <ConfirmationModalBody
            contentHeader={
                <Avatar
                    iconType={<CalendarChunkySVG />}
                    backgroundColor="grey-100"
                />
            }
            contentFooter={
                <Button
                    type="link"
                    style="fill"
                    href={`/signin/${referrerPath}`}
                >
                    {gettext('Get Started')}
                </Button>
            }
        >
            <h2 className="eds-text-hs eds-text--center">
                <span
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: SIGNIN_CONFIRMATION_TEXT.toString(),
                    }}
                />
            </h2>
        </ConfirmationModalBody>
    );
};
export default SigninConfirmationModalContent;
